<template>
  <div>
    <search abc="找大会, 找视频"></search>
    <div class="tab">
      <ul>
        <li @click="All" v-bind:class="{ active: all}">全部</li>
<!--
        <li @click="Hot" v-bind:class="{ active: hot}">热门</li>
-->
        <li @click="Now" v-bind:class="{ active: now}">最新</li>
<!--
        <li @click="Recommend" v-bind:class="{ active: recommend}">推荐</li>
-->
      </ul>
    </div>
    <div class="bars">
      <scroll-bar :url="urlcurrent"></scroll-bar>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        urlcurrent: 'api/meeting/getMeetings?',
        all: true,
        hot: false,
        now: false,
        recommend: false
      };
    },
    created() {
      window.localStorage.setItem("axiosUrl", 'subject/getMeetingInfo?mid=')
    },
    mounted() {
      this.getShareInfo()
    },
    methods: {
      All: function () {
        this.urlcurrent = 'api/meeting/getMeetings?'
        this.all = true
        this.hot = false
        this.now = false
        this.recommend = false
      },
      Hot: function () {
        this.urlcurrent = 'api/meeting/getMeetings?sort=hot&'
        this.all = false
        this.hot = true
        this.now = false
        this.recommend = false
      },
      Now: function () {
        this.urlcurrent = 'api/meeting/getMeetings?sort=new&'
        this.all = false
        this.hot = false
        this.now = true
        this.recommend = false
      },
      Recommend: function () {
        this.urlcurrent = 'api/meeting/getMeetings?sort=hot&'
        this.all = false
        this.hot = false
        this.now = false
        this.recommend = true
      }
    }
  };
</script>

<style lang="less" scoped>
  .tab ul {
    margin-left: 0px !important;
    width: 750px;
    padding: 9px 29px 0 29px;
    background-color: #f4f4f4;
    box-sizing: border-box;
    list-style: none;
    display: flex;
    margin-top: 80px;
    position: fixed;
    top: 0;
    z-index: 10;
    li {
      width: 220px;
      height: 80px;
      text-align: center;
      line-height: 80px;
      flex: 1;
	  font-size:28px;
    }
    .active {
      border-bottom: 1px solid #3e92cb; /*no*/
	  color:#3e92cb;
    }
  }

  .bars {
    margin-top: 180px;
  }
</style>




// WEBPACK FOOTER //
// src/components/Meeting/Meeting.vue